/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M21 3L15 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 21L3 16M8 21L13 16M8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3H14.5H15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M8 21L3 16M8 21L13 16M8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3L21 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M8 21L3 16M8 21L13 16M8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3L21 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3 16L8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3L21 3M13 16L10.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 21L3 16M8 21L13 16M8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3L21 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M8 21L3 16M8 21L13 16M8 21L8.00002 9.39999C8.00002 7.15978 8.00002 6.03968 8.436 5.18403C8.81949 4.43139 9.43141 3.81947 10.1841 3.43597C11.0397 3 12.1598 3 14.4 3L21 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
